import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'
import { ModalService } from '../../../../../services/modal.service'
import { SharedServices } from '../../../../../services/shared.services'
import { FormBuilder } from '@angular/forms'
import * as moment from 'moment'
import { notification } from 'onsenui'
import { MatrixServices } from '../../../../../services/image/matrix.services'
import { baseUrl, imageUrl } from '../../../../../../helper/common'
import { compact } from 'lodash'
import { Subscription } from 'rxjs'
import { User } from '@models/user'
import { TimelineHelper } from '@helpers/timeline.helper'

@Component({
    selector: 'app-modal-timeline-client-detail',
    templateUrl: './modal-timeline-client-detail.component.html',
    styleUrls: [
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/ui-schema-table-form.component.css',
        './modal-timeline-client-detail.component.css',
        '../../../../../stagingcss/image-viewer.component.css',
        '../../../../../stagingcss/radial-progress.component.css',
    ],
    providers: [MatrixServices]
})
export class ModalTimelineClientDetailComponent implements OnInit, AfterViewInit, OnDestroy {
    baseUrl = baseUrl
    imageUrl = imageUrl
    en = {}
    showEN = true
    showEditMessage = 'hidden'
    createDate
    showDate1
    timestampDate
    timestampDateDb

    hiddenModalUser = 'hidden'
    hiddenModalUserStaff = 'hidden'
    showOption: any
    filterLang: string
    showOptionStaff: any
    filterStaff: string
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    arrUser
    arrStaff
    valueCreator
    valueCreatorDeleted
    valueStaff
    valueStaffDeleted
    styleVisibility: any
    styleVisibilityStaff: any
    optionArrCopy
    noteMessage
    nextMessage
    creatorId
    StaffId
    idRoom
    creator: string
    lastEditor: string
    // image modal
    showNewImage = 'hidden'
    showNewPdf = 'hidden'
    showNewStl = 'hidden'
    statusImage = false
    statusPdf = false
    statusStl = false
    url
    arrImage = []
    arrPdf = []
    arrStl = []
    arrImageHash = []
    arrPdfHash = []
    arrStlHash = []
    hiddeniconAddImage = true
    hiddeniconAddPdf = true
    hiddeniconAddStl = true
    displayRemoveImage = true
    displayRemovePdf = true
    displayRemoveStl = true

    // edit message
    statusSave
    arrclientId
    idUpdateTimeline


    // image
    arrStyleImage = []
    arrRotate = []
    horizontalFlip = 1
    verticalFlip = 1
    arrFlip = []
    arrLoading = []
    loading = false
    statusShowImage = []
    statusShowPdf = []
    statusShowStl = []
    animationDuration
    hiddenModalImage = 'hidden'
    urlBigImage
    styleReponsiveBigImage
    matrix
    matrixImage = []
    hasBeenLoaded = false
    hasBeenEdited = false
    statusESC = false
    coordinates
    dXdYMatrixCanvas = []
    @ViewChild('inputFile') myInputVariable: ElementRef
    timelineTags = []
    selectedTags = []
    isSaveStl = false
    distroySubcribeTimeline

    private subscriptions: Array<Subscription> = []

    defaultStaff
    defaultDoctor
    private currentUser: User
    isEditNote: boolean = false

    constructor(private _sharedService: SharedServices, private authData: AuthService, private restApi: RestServices, private formBuider: FormBuilder, private modalService: ModalService, public matrixServices: MatrixServices, public el: ElementRef) {
        this.currentUser = this.authData.getUser()
        this.distroySubcribeTimeline = modalService.changeEmitted$.subscribe(success => {
            this.selectedTags = []
            if (success) {
                if (success[1] === 'showModalMessageDetail') {
                    this.nextMessage = ''
                    this.noteMessage = ''
                    this.selectedTags = []
                    this.creatorId = ''
                    this.StaffId = ''

                    this.idRoom = success[0]
                    this.showEditMessage = 'active'
                    this.hasBeenLoaded = true
                    this.statusSave = success[3]
                    if (success[3] === 'edit') {
                        this.idUpdateTimeline = success[2]
                        this.getClientId(success[2])
                    } else {
                        this.isEditNote = true
                        this.clearModal()
                    }
                    this.timelineTags = success[4]
                } else if (success[1] === 'showModalImageDetail') {
                    if (this.arrImage.length == 0) {
                        this.resetImageArr()
                    }
                    this.idRoom = success[0]
                    this.showNewImage = 'active'
                    this.hasBeenLoaded = true
                    this.statusSave = success[3]
                    if (success[3] === 'edit') {
                        this.idUpdateTimeline = success[2]
                        this.getClientId(success[2])
                    } else {
                        this.isEditNote = true
                        this.resetImageArr()
                        this.clearModal()
                    }
                    this.timelineTags = success[4]

                } else if (success[1] === 'showModalPdfDetail') {
                    if (this.arrPdf.length == 0) {
                        this.arrPdf.push('init')
                    }
                    this.idRoom = success[0]
                    this.showNewPdf = 'active'
                    this.hasBeenLoaded = true
                    this.statusSave = success[3]
                    if (success[3] === 'edit') {
                        this.idUpdateTimeline = success[2]
                        this.getClientId(success[2])
                    } else {
                        this.isEditNote = true
                        this.clearModal()
                    }
                    this.timelineTags = success[4]

                } else if (success[1] === 'showBigImageDetail') {
                    this.hiddenModalImage = 'active'
                    this.loading = true
                    setTimeout(() => {
                        this.urlBigImage = success[0]
                        this.loading = false
                        this.matrix = success[2] ? success[2] : [1, 0, 0, 1]
                        // this.items.push(0);
                    }, 500)
                } else if (success[1] === 'showModalStlDetail') {
                    if (this.arrStl.length == 0) {
                        this.arrStl.push('init')
                    }
                    this.idRoom = success[0]
                    this.showNewStl = 'active'
                    this.hasBeenLoaded = true
                    this.statusSave = success[3]
                    if (success[3] === 'edit') {
                        this.idUpdateTimeline = success[2]
                        this.getClientId(success[2])
                    } else {
                        this.isEditNote = true
                    }
                    this.timelineTags = success[4]

                }
            }
        })
    }

    ngOnInit() {
        this.resetImageArr()
        this.arrPdf.push('init')
        this.matrixServices.arrStyleImage.push(0)
        this.showDate1 = moment().format('YYYY.MM.DD ddd')
        this.timestampDateDb = moment(Date.now()).utc().startOf('day').valueOf()
        // this.setMatrix();
        // this.arrstatusImage.push(undefined);
    }

    setMatrix() {
        if (this.arrclientId && this.arrclientId['images']) {
            this.initArrayMatrix(this.arrclientId['images'])
        } else {
            setTimeout(() => {
                this.setMatrix()
                // this.items.push(0);
            }, 200)
        }
    }

    ngOnDestroy() {
        if(this.distroySubcribeTimeline)
            this.distroySubcribeTimeline.unsubscribe()
    }

    // add or remove selected tags
    toggleTag(item) {
        this.markChanged()
        const found = this.selectedTags.findIndex((e) => {
            return e == item._id
        })
        if (found == -1) {
            this.selectedTags.push(item._id)
        } else {
            this.selectedTags.splice(found, 1)
        }
    }

    // check tag is selected
    checkActiveTag(item) {
        const found = this.selectedTags.findIndex((e) => {
            return e === item._id
        })
        if (found !== -1) {
            return true
        }
        return false
    }

    ngAfterViewInit(): void {

    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        let keyPressed = event.keyCode
        if (keyPressed === 27) {
            event.preventDefault()
            if (this.statusESC) {
                this.statusESC = false
                this.hiddenModalUser = 'hidden'
                this.hiddenModalUserStaff = 'hidden'
            } else {
                if (this.hasBeenEdited) {
                    this.changeLanguage()
                    notification.confirm({
                        message: this.en['alert-content-discard'],
                        title: '<b>' + this.en['alert-discard'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], 'OK'],
                        callback: i => {
                            if (i === 1) {
                                this.showEditMessage = 'hidden'
                                this.showNewImage = 'hidden'
                                this.showNewPdf = 'hidden'
                                this.resetModel()
                            }
                        },
                    })
                } else {
                    this.showEditMessage = 'hidden'
                    this.showNewImage = 'hidden'
                    this.showNewPdf = 'hidden'
                    this.resetModel()
                }
            }
        }
    }

    // ******************* IMAGE **************************** //
    // loadSizeImage(img, container, i) {
    //     this.matrixServices.loadSizeImage(img, container, i);
    // }

    hiddenModalBigImage() {
        this.hiddenModalImage = 'hidden'
        this.urlBigImage = undefined
    }

    // big Image
    reponsiveImage(sizeImage, widthBigImage, matrixImage) {
        const n1 = (widthBigImage.offsetHeight / sizeImage.clientHeight) * (matrixImage[0]) // n1
        const n2 = (widthBigImage.offsetHeight / sizeImage.clientWidth) * (matrixImage[1]) // n2
        const n3 = (widthBigImage.offsetHeight / sizeImage.clientWidth) * (matrixImage[2]) // n3
        const n4 = (widthBigImage.offsetHeight / sizeImage.clientHeight) * (matrixImage[3]) // n4
        const n5 = (widthBigImage.offsetWidth - sizeImage.clientWidth) / 2
        const n6 = (widthBigImage.offsetHeight - sizeImage.clientHeight) / 2
        this.styleReponsiveBigImage = {
            'transform': 'matrix(' + n1 + ', ' + n2 + ', ' + n3 + ', ' + n4 + ',' + n5 + ',' + n6 + ')',
        }
    }

    showBigImage(id, matrix) {
        const arrImage = [id, 'showBigImage', matrix]
        this._sharedService.emitChange(arrImage)
    }


    // ******************* IMAGE **************************** //

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    hidenModalMessage() {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.showEditMessage = 'hidden'
                        this.resetModel()
                    }
                },
            })
        } else {
            this.showEditMessage = 'hidden'
            this.resetModel()
        }
    }

    hidenModalImage() {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.showNewImage = 'hidden'
                        this.resetModel()
                    }
                },
            })
        } else {
            this.resetModel()
            this.showNewImage = 'hidden'
        }
    }

    hidenModalPdf() {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.showNewPdf = 'hidden'
                        this.resetModel()
                    }
                },
            })
        } else {
            this.resetModel()
            this.showNewPdf = 'hidden'
        }
    }

    hidenModalStl() {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.showNewStl = 'hidden'
                        this.resetModel()
                    }
                },
            })
        } else {
            this.resetModel()
            this.showNewStl = 'hidden'
        }
    }

    // show theme date
    formatCreateDate(event) {
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        if (event) {
            const setTimestamp = moment(event['_d'])
            setTimestamp.set({ hours: 10 })
            const timestamp = moment(setTimestamp).startOf('day').valueOf()
            this.showDate1 = moment(timestamp).format('YYYY.MM.DD ddd')
            this.timestampDate = timestamp
            this.timestampDateDb = moment(setTimestamp).utc().startOf('day').valueOf()
            this.createDate = moment(timestamp)
        } else {
            const timestamp = moment(Date.now()).utc().startOf('day').valueOf()
            this.showDate1 = moment(Date.now()).format('YYYY.MM.DD ddd')
            this.timestampDateDb = timestamp
        }

    }

    nextDate(timestampAdd, day) {
        this.markChanged()
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).add(day, 'days').startOf('day').valueOf()
        const timestampDateDb = moment(adDate['_d']).utc().add(addTime, 'hours').add(day, 'days').startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.timestampDateDb = timestampDateDb
        this.showDate1 = showdateAdd
        this.createDate = moment(timestampDate)
    }

    prevDate(timestampAdd, day) {
        this.markChanged()

        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).subtract(day, 'days').startOf('day').valueOf()
        const timestampDateDb = moment(adDate['_d']).utc().add(addTime, 'hours').subtract(day, 'days').startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.timestampDateDb = timestampDateDb
        this.showDate1 = showdateAdd
        this.createDate = moment(timestampDate)
    }

    hidenModal() {
        this.hiddenModalUser = 'hidden'
        this.hiddenModalUserStaff = 'hidden'
        this.statusESC = false
    }

    selectOption(id, value) {
        this.showOption = 'showOption_' + id
        this.defaultDoctor = id
        if (this.showOption) {
            this.valueCreator = value
            this.valueCreatorDeleted = undefined
            this.creatorId = id
            this.styleVisibility = { visibility: 'visible' }
            this.hidenModal()
            this.markChanged()
        }
    }

    // search language
    searchStaff(): void {
        const term = this.filterStaff
        this.arrStaff = this.optionArrCopy.filter(function(tag) {
            return tag.firstName && tag.firstName.indexOf(term) >= 0 || tag.familyName && tag.familyName.indexOf(term) >= 0
        })
    }

    selectOptionStaff(id, value) {
        this.showOptionStaff = 'showOption_' + id
        this.defaultStaff = id
        if (this.showOptionStaff) {
            this.valueStaff = value
            this.valueStaffDeleted = undefined
            this.StaffId = id
            this.styleVisibilityStaff = { visibility: 'visible' }
            this.hidenModal()
            this.markChanged()
        }
    }

    // search language
    search(): void {
        const term = this.filterLang
        this.arrUser = this.optionArrCopy.filter(function(tag) {
            return tag.firstName && tag.firstName.indexOf(term) >= 0 || tag.familyName && tag.familyName.indexOf(term) >= 0
        })
    }

    // get list user
    listUser() {
        this.hiddenModalUser = 'active'
        this.statusESC = true
        const resourceUrl = 'resource'
        const resourceData = this.restApi.makeResourceObject({
            status: {
                NewRomm: {
                    paths: {
                        '{}': true,
                    },
                },
            },
        })
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.arrUser = success['response']['staff']['searches']["{\"deleted\": {\"$ne\": true}}"]
                this.optionArrCopy = this.arrUser.slice() // copy of optionArr
                if (this.defaultDoctor) {
                    this.showOption = 'showOption_' + this.defaultDoctor
                    this.styleVisibility = { visibility: 'visible' }
                }
                if (this.arrUser) {
                    this.arrUser.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                }
            })
        })
    }

    listStaff() {
        this.hiddenModalUserStaff = 'active'
        this.statusESC = true
        const resourceUrl = 'resource'
        const resourceData = this.restApi.makeResourceObject({
            status: {
                NewRomm: {
                    paths: {
                        '{}': true,
                    },
                },
            },
        })
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.arrStaff = success['response']['staff']['searches']["{\"deleted\": {\"$ne\": true}}"]
                this.optionArrCopy = this.arrStaff.slice() // copy of optionArr
                if (this.defaultStaff) {
                    this.showOptionStaff = 'showOption_' + this.defaultStaff
                    this.styleVisibilityStaff = { visibility: 'visible' }
                }
                if (this.arrStaff) {
                    this.arrStaff.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                }
            })
        })
    }

    // save message
    saveMessage(statusSave) {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        if (statusSave === 'edit') {
                            this.sendMessageRequest('update')
                        } else {
                            this.sendMessageRequest('create')
                        }
                    }
                },
            })
        } else {
            this.showEditMessage = 'hidden'
            this.resetModel()
        }
    }

    sendMessageRequest(type) {
        if (!this.isEditNote) {
            return
        }

        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true
        const { staffId } = this.currentUser
        if (staffId) {
            this.lastEditor = staffId
            if (type === 'create') {
                this.creator = staffId
            }
        }

        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                type: type, id: type == 'create' ? null : this.idUpdateTimeline, collection: 'clientNote', value: {
                    note: this.noteMessage, next: this.nextMessage, visitDate: this.timestampDateDb,
                    clientId: this.idRoom, doctor: this.creatorId, staff: this.StaffId, tags: this.selectedTags,
                    creator: this.creator,
                    lastEditor: this.lastEditor
                },
            }], status: {
                clientNote: {
                    paths: clientId, searches: clientId,
                },
            },
        })

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showEditMessage = 'hidden'
                const listTimeline = success['response']['clientNote']['searches']['{"clientId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline, this.idUpdateTimeline]
                this._sharedService.emitChange(arrTimeline)

                this.resetModel()
            })
        })
    }

    markChanged() {
        if (this.hasBeenLoaded) {
            this.hasBeenEdited = true
        }
    }

    // *********************************************************** *************************MODAL IMAGE **********************************************************************//
    allowDrop(e) {
        e.preventDefault()
    }

    drop(e, i) {
        e.preventDefault()
        this.markChanged()

        this.handleFileInput(e.dataTransfer.files, e, i)
    }

    dropPdf(e, i) {
        e.preventDefault()
        this.markChanged()
        this.handleFilePdfInput(e.dataTransfer.files, e, i)
    }

    dropStl(e, i) {
        e.preventDefault()
        this.markChanged()
        this.handleFileStlInput(e.dataTransfer.files, e, i)
    }

    handleFileInput(files: FileList, event, startIndex) {
        if (files && files[0]) {
            let fileNum = 0
            if (this.statusSave == 'edit' && this.arrclientId && this.arrclientId['images'] && this.arrclientId['images'].length > 0) {
                if (this.matrixServices.arrFlip.length < this.arrclientId['images'].length) {
                    this.initArrayMatrix(this.arrclientId['images'])
                }
            }

            this.authData.authToken().then(tokenReNew => {
                let idx
                const fileCount = files.length
                for (idx = 0; idx < fileCount; idx++) {
                    const file = files[idx]

                    if (file && file['type'] === 'image/jpeg' || file['type'] === 'image/png' || file['type'] === 'image/tiff') {
                        let i = startIndex + fileNum

                        if (!this.arrImage[i]) {
                            this.addImage(event, false)
                        }

                        let reader = new FileReader()
                        reader.readAsDataURL(file) // read file as data url

                        reader.onload = (event: any) => { // called once readAsDataURL is completed
                            this.url = event.target.result
                            // this.arrstatusImage.splice(i, 1, i);
                            this.statusImage = true
                            // this.arrLoading.push(true);
                            this.arrLoading.splice(i, 1, true)
                            this.animationDuration = 2800
                        }
                        this.loading = true
                        this.statusShowImage.splice(i, 1, true)

                        this.subscriptions.push(this.restApi.postFile(file, tokenReNew).subscribe(success => {
                            this.matrixImage.splice(i, 1, [1, 0, 0, 1])
                            const hashUrl = success['hash']
                            const idImage = {
                                id: hashUrl, matrix: this.matrixImage[i],
                            }

                            // this.matrixServices.arrImageHash.splice(i, 1, idImage);
                            this.arrImageHash.splice(i, 1, idImage)
                            const url = imageUrl + hashUrl

                            this.arrImage.splice(i, 1, url)
                            this.arrLoading.splice(i, 1, false)
                            this.statusShowImage.splice(i, 1, false)
                        }))

                        fileNum++
                    }
                }

                this.reset()
            })

        }
    }

    handleFilePdfInput(files: FileList, event, i) {
        if (files && files[0]) {
            const file = files[0]
            if (file['type'] === 'application/pdf') {
                const reader = new FileReader()
                reader.readAsDataURL(file) // read file as data url

                reader.onload = (event: any) => { // called once readAsDataURL is completed
                    this.url = event.target.result
                    // this.arrstatusImage.splice(i, 1, i);
                    this.statusPdf = true
                    // this.arrLoading.push(true);
                    this.arrLoading.splice(i, 1, true)
                    this.animationDuration = 2800
                }
                this.loading = true
                this.statusShowPdf.splice(i, 1, true)
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(file, tokenReNew).subscribe(success => {
                        const hashUrl = success['hash']
                        const idPdf = {
                            id: hashUrl,
                            name: file.name,
                        }
                        // this.matrixServices.arrImageHash.splice(i, 1, idImage);
                        this.arrPdfHash.splice(i, 1, idPdf)
                        const url = imageUrl + hashUrl

                        this.arrPdf.splice(i, 1, url)
                        this.arrLoading.splice(i, 1, false)
                        this.statusShowPdf.splice(i, 1, false)
                    })
                })
            }
        }
    }

    handleFileStlInput(files: FileList, event, i) {
        if (files && files[0]) {
            const file = files[0]
            if (file['type'] === 'model/stl' || file['type'] === 'application/sla' || file['type'] === '') {
                const reader = new FileReader()
                reader.readAsDataURL(file) // read file as data url
                this.isSaveStl = true
                reader.onload = (event: any) => { // called once readAsDataURL is completed
                    this.url = event.target.result
                    // this.arrstatusImage.splice(i, 1, i);
                    this.statusStl = true
                    // this.arrLoading.push(true);
                    this.arrLoading.splice(i, 1, true)
                    this.animationDuration = 2800
                    if (this.url.slice(0, 40).indexOf('application/octet-stream') < 0) {
                        return
                    }
                }
                this.loading = true
                this.statusShowStl.splice(i, 1, true)
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(file, tokenReNew).subscribe(success => {
                        const hashUrl = success['hash']
                        const idStl = {
                            id: hashUrl,
                            name: file.name,
                        }
                        // this.matrixServices.arrImageHash.splice(i, 1, idImage);
                        this.arrStlHash.splice(i, 1, idStl)
                        const url = imageUrl + hashUrl

                        this.arrStl.splice(i, 1, url)
                        this.arrLoading.splice(i, 1, false)
                        this.statusShowStl.splice(i, 1, false)
                        this.isSaveStl = false
                    })
                })
            }
        }
    }

    addImage(event, resetInput = true) {
        this.markChanged()
        if (resetInput)
            this.reset()
        this.arrImage.push('init')
        this.arrImageHash.push('init')
        this.arrLoading.push(false)
        this.matrixServices.arrStyleImage.push('')

        this.matrixImage.push([1, 0, 0, 1])
        // this.arrstatusImage.push(undefined);
        this.displayRemoveImage = false
        this.hiddeniconAddImage = false
        this.statusImage = false
        this.statusShowImage.push(false)
    }

    addPdfFile(event) {
        this.markChanged()
        this.reset()
        this.arrPdf.push('init')
        // this.arrstatusImage.push(undefined);
        this.displayRemovePdf = false
        this.hiddeniconAddPdf = false
        this.statusPdf = false
        this.statusShowPdf.push(false)
    }

    addStlFile(event) {
        if (this.arrStl[this.arrStl.length - 1] == 'init') {
            return
        }
        this.markChanged()
        this.reset()
        this.arrStl.push('init')
        // this.arrstatusImage.push(undefined);
        this.displayRemoveStl = false
        this.hiddeniconAddStl = false
        this.statusStl = false
        this.statusShowStl.push(false)
    }

    removeImage(index) {
        this.markChanged()
        this.arrStyleImage = this.matrixServices.arrStyleImage
        this.arrFlip = this.matrixServices.arrFlip
        this.arrImage.splice(index, 1)
        this.arrImageHash.splice(index, 1)
        if (this.arrImage.length === 0) {
            this.resetImageArr()
            this.displayRemoveImage = true
        }
        this.arrStyleImage.splice(index, 1)
        this.arrLoading.splice(index, 1, false)
        this.arrFlip.splice(index, 1)
        this.matrixServices.arrRotate.splice(index, 1)
        if (this.matrixServices.arrImage.length > this.arrImage.length) {
            this.matrixServices.arrImage.splice(index, 1)
            this.matrixServices.arrImageHash.splice(index, 1)

        }
        if (this.matrixServices.arrStyleImage.length > this.matrixServices.arrImage.length) {
            this.matrixServices.arrStyleImage.splice(index, 1)
        }
        // this.matrixServices.arrStyleImage.splice(index, 1);
    }

    removePdf(index) {
        this.markChanged()
        this.arrPdf.splice(index, 1)
        this.arrPdfHash.splice(index, 1)
        if (this.arrPdf.length === 0) {
            this.arrPdf.push('init')
            this.displayRemovePdf = true
        }
        this.arrLoading.splice(index, 1, false)
    }

    removeStl(index) {
        this.markChanged()
        this.arrStl.splice(index, 1)
        this.arrStlHash.splice(index, 1)
        if (this.arrStl.length === 0) {
            this.arrStl.push('init')
            this.displayRemoveStl = true
        } else {
            if (this.arrStl.includes('init')) {
                // this.isSavePdf = true
                this.displayRemoveStl = true
            }
        }
        this.arrLoading.splice(index, 1, false)
    }

    saveImage(statusSave) {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i != -1) {
                        if (i === 1) {  // here this is not cancelled.  1 is correct.
                            this.matrixImage = this.matrixServices.matrixImage
                            this.arrImageHash = this.matrixServices.arrImageHash
                            this.arrImage = this.matrixServices.arrImage
                            if (this.arrImage.length == 0) {
                                this.resetImageArr()
                            }
                            if (statusSave === 'edit') {
                                this.sendImageRequest('update')
                            } else {
                                this.sendImageRequest('create')
                            }
                        }
                    }
                },
            })
        } else {
            this.resetModel()
            this.showNewImage = 'hidden'
        }
    }

    savePdf(statusSave) {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i != -1) {
                        if (i === 1) {  // here this is not cancelled.  1 is correct.
                            if (this.arrPdfHash.length == 0) {
                                this.arrPdfHash.push('init')
                            }
                            if (statusSave === 'edit') {
                                this.sendPdfRequest('update')
                            } else {
                                this.sendPdfRequest('create')
                            }
                        }
                    }
                },
            })
        } else {
            this.resetModel()
            this.showNewPdf = 'hidden'
        }
    }

    saveStl(statusSave) {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i != -1) {
                        if (i === 1) {  // here this is not cancelled.  1 is correct.
                            if (this.arrStlHash.length == 0) {
                                this.arrStlHash.push('init')
                            }
                            if (statusSave === 'edit') {
                                this.sendStlRequest('update')
                            } else {
                                this.sendStlRequest('create')
                            }
                        }
                    }
                },
            })
        } else {
            this.resetModel()
            this.showNewStl = 'hidden'
        }
    }

    sendImageRequest(type) {
        if (!this.isEditNote) {
            return
        }

        this.arrImageHash = this.arrImageHash.filter((item) => {
            return item !== 'init'
        })
        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true
        const { staffId } = this.currentUser
        if (staffId) {
            this.lastEditor = staffId
            if (type === 'create') {
                this.creator = staffId
            }
        }

        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                type: type, id: type == 'create' ? null : this.idUpdateTimeline, collection: 'clientNote', value: {
                    note: this.noteMessage, visitDate: this.timestampDateDb, clientId: this.idRoom,
                    staff: this.StaffId, images: compact(this.arrImageHash), type: 'image', tags: this.selectedTags,
                    creator: this.creator,
                    lastEditor: this.lastEditor
                },
            }], status: {
                clientNote: {
                    paths: clientId, searches: clientId,
                },
            },
        })

        delete resourceData.status.clinic

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showNewImage = 'hidden'
                const listTimeline = success['response']['clientNote']['searches']['{"clientId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)

                this.resetModel()
                this.matrixServices.resetMatrix()
            })
        })
    }

    sendPdfRequest(type) {
        if (!this.isEditNote) {
            return
        }

        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true
        const { staffId } = this.currentUser
        if (staffId) {
            this.lastEditor = staffId
            if (type === 'create') {
                this.creator = staffId
            }
        }
        
        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                type: type, id: type == 'create' ? null : this.idUpdateTimeline, collection: 'clientNote', value: {
                    note: this.noteMessage, visitDate: this.timestampDateDb, clientId: this.idRoom,
                    staff: this.StaffId, pdfs: compact(this.arrPdfHash), type: 'pdf', tags: this.selectedTags,
                    creator: this.creator,
                    lastEditor: this.lastEditor
                },
            }], status: {
                clientNote: {
                    paths: clientId, searches: clientId,
                },
            },
        })

        delete resourceData.status.clinic

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showNewPdf = 'hidden'
                const listTimeline = success['response']['clientNote']['searches']['{"clientId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)

                this.resetModel()
            })
        })
    }

    sendStlRequest(type) {
        if (!this.isEditNote) {
            return
        }

        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true
        const { staffId } = this.currentUser
        if (staffId) {
            this.lastEditor = staffId
            if (type === 'create') {
                this.creator = staffId
            }
        }

        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                type: type, id: type == 'create' ? null : this.idUpdateTimeline, collection: 'clientNote', value: {
                    note: this.noteMessage, visitDate: this.timestampDateDb, clientId: this.idRoom,
                    staff: this.StaffId, stls: compact(this.arrStlHash), type: 'stl', tags: this.selectedTags,
                    creator: this.creator,
                    lastEditor: this.lastEditor
                },
            }], status: {
                clientNote: {
                    paths: clientId, searches: clientId,
                },
            },
        })

        delete resourceData.status.clinic

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showNewStl = 'hidden'
                const listTimeline = success['response']['clientNote']['searches']['{"clientId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)

                this.resetModel()
            })
        })
    }

    // ****************************************************************** EDIT MESSAGE ***************************************************** //
    getClientId(idRoom) {
        const resourceUrl = 'resource'
        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true
        const map = {}
        map[idRoom] = true
        const resourceData = this.restApi.makeResourceObject({
            status: {
                clientNote: {
                    map, paths: clientId, searches: clientId,
                },
            },
        })
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {

                this.arrclientId = success['response']['clientNote']['map'][idRoom]
                if (this.arrclientId['images'] && Array.isArray(this.arrclientId['images'])) {
                    this.initArrayMatrix(this.arrclientId['images'])
                } else if (this.arrclientId['pdfs'] && Array.isArray(this.arrclientId['pdfs'])) {
                    this.initPdfs(this.arrclientId['pdfs'])
                } else if (this.arrclientId['stls'] && Array.isArray(this.arrclientId['stls'])) {
                    this.initStls(this.arrclientId['stls'])
                }
                this.createDate = moment(this.arrclientId['visitDate'])
                this.timestampDate = this.arrclientId['visitDate']
                this.noteMessage = this.arrclientId['note']
                this.nextMessage = this.arrclientId['next']
                const staff = success['response']['staff']['paths']['{}']
                for (let i = 0; i <= staff.length; i++) {
                    if (staff[i] && staff[i]['_id'] === this.arrclientId.doctor) {
                        this.valueCreator = (staff[i].firstName || '') + ' ' + (staff[i].familyName || '')
                        this.valueCreatorDeleted = staff[i].deleted
                    }
                    if (staff[i] && staff[i]['_id'] === this.arrclientId.staff) {
                        this.valueStaff = (staff[i].firstName || '') + ' ' + (staff[i].familyName || '')
                        this.valueStaffDeleted = staff[i].deleted
                    }
                }
                this.creatorId = this.arrclientId.doctor
                this.StaffId = this.arrclientId.staff
                this.defaultStaff = this.arrclientId.staff
                this.defaultDoctor = this.arrclientId.doctor
                this.selectedTags = this.arrclientId['tags'] ? this.arrclientId['tags'] : []
                this.creator = this.arrclientId.creator
                this.isEditNote = TimelineHelper.canCurrentUserEdit(this.currentUser, this.creator)
                this.lastEditor = this.arrclientId.lastEditor
                setTimeout(() => {
                    // this.loading = false;
                    if (this.arrLoading.length) {
                        for (let a = 0; a < this.arrLoading.length; a++) {
                            this.arrLoading.splice(a, 1, false)
                        }
                    }
                }, 500)
                return this.arrclientId
            })
        })
        return {}
    }

    initPdfs(arrayPdfs: any[] = []) {
        this.arrPdfHash = []
        this.arrPdf = []
        this.arrLoading = []
        this.displayRemovePdf = false

        const tpmArrPdfHash: any[] = []
        const tmpArrPdf: any[] = []

        if (arrayPdfs && arrayPdfs.length > 0) {
            arrayPdfs.forEach((el, i) => {
                tpmArrPdfHash.push(el)
                if (el && el['id']) {
                    this.url = imageUrl + el['id']
                    tmpArrPdf.push(this.url)
                }
                this.arrLoading.push(false)
            })
            this.arrPdfHash = jQuery.extend(true, [], tpmArrPdfHash)
            this.arrPdf = jQuery.extend(true, [], tmpArrPdf)
        }

        if (this.arrPdf.length === 0) {
            this.arrPdf.push('init')
            this.displayRemovePdf = true
        }
    }

    initStls(arrayStls: any[] = []) {
        this.arrStlHash = []
        this.arrStl = []
        this.arrLoading = []
        this.displayRemoveStl = false

        const tpmArrStlHash: any[] = []
        const tmpArrStl: any[] = []

        if (arrayStls && arrayStls.length > 0) {
            arrayStls.forEach((el, i) => {
                tpmArrStlHash.push(el)
                if (el && el['id']) {
                    this.url = imageUrl + el['id']
                    tmpArrStl.push(this.url)
                }
                this.arrLoading.push(false)
            })
            this.arrStlHash = jQuery.extend(true, [], tpmArrStlHash)
            this.arrStl = jQuery.extend(true, [], tmpArrStl)
        }

        if (this.arrStl.length === 0) {
            this.arrStl.push('init')
            this.displayRemoveStl = true
        }
    }

    initArrayMatrix(arrayGeneral: any[] = []) {
        this.animationDuration = 300
        this.displayRemoveImage = false
        this.arrImageHash = []
        this.arrImage = []
        //matrix
        this.matrixImage = []
        const matrix = [1, 0, 0, 1]
        const arrRotate: any[] = []
        const arrStyleImage: any[] = []
        const arrFlip: any[] = []
        const jsonFlip: any = {}
        jsonFlip['horizontalFlip'] = 1
        jsonFlip['verticalFlip'] = 1
        this.arrLoading = []
        const tpmArrImageHash: any[] = []
        const tmpArrayMatrixImage: any[] = []
        const tmpArrImage: any[] = []
        const dxdyMatrix: any[] = []

        if (arrayGeneral && arrayGeneral.length > 0) {
            arrayGeneral.forEach((el, i) => {
                if (el) {
                    if (el && el['matrix']) {
                        tmpArrayMatrixImage.push(el['matrix'])
                    } else {
                        tmpArrayMatrixImage.push(matrix)
                    }
                    tpmArrImageHash.push(el)
                    if (el && el['id']) {
                        this.url = imageUrl + el['id']
                        tmpArrImage.push(this.url)
                    }
                    // this.arrImageHash.push({});
                    arrRotate.push(0)
                    arrStyleImage.push('')
                    arrFlip.push(jsonFlip)
                    dxdyMatrix.push(0)
                    // this.arrayMatrixImage.push(matrix);
                    this.arrLoading.push(false)
                }
            })
            this.matrixImage = jQuery.extend(true, [], tmpArrayMatrixImage)
            this.arrImageHash = jQuery.extend(true, [], tpmArrImageHash)
            this.arrImage = jQuery.extend(true, [], tmpArrImage)
            
            if (this.matrixServices.arrFlip.length < arrFlip.length) {
                this.matrixServices.arrImage = jQuery.extend(true, [], this.arrImage)
                this.matrixServices.matrixImage = jQuery.extend(true, [], this.matrixImage)
                this.matrixServices.arrImageHash = jQuery.extend(true, [], this.arrImageHash)
                this.matrixServices.arrRotate = jQuery.extend(true, [], arrRotate)
                this.matrixServices.arrStyleImage = jQuery.extend(true, [], arrStyleImage)
                this.matrixServices.arrFlip = jQuery.extend(true, [], arrFlip)
                this.matrixServices.dXdYMatrixCanvas = jQuery.extend(true, [], dxdyMatrix)
            }
        }
        if (this.arrImage.length === 0) {
            this.resetImageArr()
            this.displayRemoveImage = true
        }
    }

    // ************************************************************* REMOVE TIMELINNE ************************************************************ //
    removeTimeline(idTimeLine) {
        this.changeLanguage()
        notification.confirm({
            message: this.en['alert-content-2'],
            title: '<b>' + this.en['alert-remove'] + '</b>',
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], 'OK'],
            callback: i => {
                if (i === 1) {  // here this is not cancelled.  1 is correct.
                    this.removeTimelineId(idTimeLine)
                }
            },
        })
    }

    removeTimelineId(idTimeLine) {
        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true
        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                type: 'remove', id: idTimeLine, collection: 'clientNote',
            }], status: {
                clientNote: {
                    paths: clientId, searches: clientId,
                },
            },
        })
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showEditMessage = 'hidden'
                this.showNewImage = 'hidden'
                this.showNewPdf = 'hidden'
                const listTimeline = success['response']['clientNote']['searches']['{"clientId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.resetModel()
            })
        })
    }

    resetModel() {
        this.noteMessage = undefined
        this.creatorId = undefined
        this.valueCreator = undefined
        this.valueCreatorDeleted = undefined
        this.StaffId = undefined
        this.valueStaff = undefined
        this.valueStaffDeleted = undefined
        this.showOption = undefined
        this.showOptionStaff = undefined
        this.arrPdf = ['init']
        this.arrStl = ['init']
        this.statusSave = undefined
        this.matrixImage = []
        this.arrPdfHash = []
        this.arrStlHash = []
        this.arrFlip = []
        this.arrRotate = []
        this.arrLoading = []
        //this.createDate = moment(Date.now())
        this.createDate = moment(Date.now()).utc().startOf('day').valueOf()

        this.dXdYMatrixCanvas = []
        this.matrixServices.arrStyleImage = [];
        this.matrixServices.resetMatrix();

        this.hasBeenEdited = false
        this.statusShowImage = []
        this.statusShowPdf = []
        this.statusShowStl = []
        this.resetImageArr()

        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe()
        })
        this.loading = false

    }

    reset() {
        this.myInputVariable.nativeElement.value = ''
    }

    removePhoto(index) {
        this.arrImage.splice(index, 1, 'init')
        this.arrImageHash.splice(index, 1, undefined)
        this.arrLoading.splice(index, 1, false)
    }

    downloadPdf(event, id, name) {
        event.stopPropagation()

        this.authData.authToken().then(tokenReNew => {
            this.restApi.downloadFile(tokenReNew, id, name)
        })

    }

    downloadStl(event, id, name) {
        event.stopPropagation()

        this.authData.authToken().then(tokenReNew => {
            this.restApi.downloadFile(tokenReNew, id, name)
        })

    }

    resetImageArr() {
        this.arrImage = ['init']
        this.arrImageHash = ['init']
        this.arrStyleImage = []
        this.matrixServices.arrStyleImage = ['']
        this.matrixImage = [[1, 0, 0, 1]]
    }

    clearModal() {
        this.styleVisibilityStaff = { visibility: 'hidden' }
        this.styleVisibility = { visibility: 'hidden' }
        this.defaultDoctor = undefined
        this.defaultStaff = undefined
    }

    trackByFn(index: number, item: any) {
        return item.id;
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/timeline/timeline/modal-timeline-client-detail.component.ts